import { render } from "./CoursesHeader.vue?vue&type=template&id=72747ae5&scoped=true"
import script from "./CoursesHeader.vue?vue&type=script&lang=js"
export * from "./CoursesHeader.vue?vue&type=script&lang=js"

import "./CoursesHeader.vue?vue&type=style&index=0&id=72747ae5&scoped=true&lang=css"
import "./CoursesHeader.vue?vue&type=style&index=1&id=72747ae5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72747ae5"]])

export default __exports__